import { CashTransferStatus, PlayerBalanceWithdrawal, PlayerBalanceWithdrawalFilterField, PayoutMethodEnum } from '@/generated/graphql';

import { IPlayer, mapGQLPlayer } from './player';
import { ICashier, mapGQLCashier } from './cashier';
import { IAuditor, mapGQLAuditor } from './auditor';

export interface IPlayerBalanceWithdrawal {
  id: string;
  amount: number;
  referenceId: string;
  transactionType: PayoutMethodEnum;
  notes: string;
  status: CashTransferStatus;
  senderAccountNumber: string;
  receiverAccountNumber: string;

  createdAt: string;
  updatedAt: string;

  player: IPlayer;
  cashier: ICashier;
  auditor: IAuditor;
}

export interface IPlayerBalanceWithdrawalQueryVariable {
  first: number;
  after?: string;
  before?: string;
  filterBy?: PlayerBalanceWithdrawalFilterField;
}

export interface IPlayerBalanceWithdrawalTable {
  id: string;
  amountDisplay: string;
  transactionType: PayoutMethodEnum;
  createdAt: string;
  receiverAccountNumber: string;

  playerName: string;
  cashierName: string;
  cashierId: string;
  notes: string;
  status: CashTransferStatus;
}

export interface IPlayerWithdrawalTransactionTable {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: PayoutMethodEnum;

  playerName: string;
  auditorName: string;
  senderAccountNumber: String;
  receiverAccountNumber: String;
}

export interface IPlayerWithdrawalTransactionTable_AD {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: PayoutMethodEnum;

  playerName: string;
  cashierName: string;
  auditorId: string;
  senderAccountNumber: String;
  receiverAccountNumber: String;
}

export function mapGQLPlayerBalanceWithdrawal(gql_playerBalanceWithdrawal?: PlayerBalanceWithdrawal | null): IPlayerBalanceWithdrawal {
  return {
    id: gql_playerBalanceWithdrawal?.id ?? '',
    amount: gql_playerBalanceWithdrawal?.amount ?? 0,
    referenceId: gql_playerBalanceWithdrawal?.referenceId ?? '',
    transactionType: gql_playerBalanceWithdrawal?.transactionType ?? PayoutMethodEnum.Gcash,
    notes: gql_playerBalanceWithdrawal?.notes ?? '',
    status: gql_playerBalanceWithdrawal?.status ?? CashTransferStatus.Pending,
    receiverAccountNumber: gql_playerBalanceWithdrawal?.receiverAccountNumber ?? '',
    senderAccountNumber: gql_playerBalanceWithdrawal?.senderAccountNumber ?? '',

    updatedAt: gql_playerBalanceWithdrawal ? gql_playerBalanceWithdrawal.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    createdAt: gql_playerBalanceWithdrawal
      ? new Date(gql_playerBalanceWithdrawal.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',

    player: mapGQLPlayer(gql_playerBalanceWithdrawal?.player),
    cashier: mapGQLCashier(gql_playerBalanceWithdrawal?.cashier),
    auditor: mapGQLAuditor(gql_playerBalanceWithdrawal?.auditor),
  };
}
